import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import ButtonGroup from "@/Common/Components/Buttons/ButtonGroup";
import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { Person } from "@/Common/Models/Person/Person";
import { DisplayPatientComparison } from "./DisplayPatientComparison";

interface IPatientMergeRequestCancellationConfirmationPopupProps {
    onClose: () => void;
    onConfirm: () => void;
    patientA: Person;
    patientB: Person;
}

function PatientMergeRequestCancellationConfirmationPopup({ onClose, onConfirm, patientA, patientB }: Readonly<IPatientMergeRequestCancellationConfirmationPopupProps>): JSX.Element {
    const { getText } = useTranslation();

    return (
        <Modal
            title={getText("WarningLabel")}
            showX
            showOverlay
            onClose={onClose}
            footer={(
                <div className="flex-display flex-end">
                    <ButtonGroup>
                        <ButtonControl
                            variant="neutral"
                            label={getText("CancelLabel")}
                            onClick={onClose}
                        />
                        <ButtonControl
                            variant="brand"
                            label={getText("ConfirmLabel")}
                            onClick={onConfirm}
                        />
                    </ButtonGroup>
                </div>
            )}
        >
            <p>{getText("PatientMergeRequestPopup_CancelPatientMergeRequestLabel")}</p>
            <DisplayPatientComparison patientA={patientA} patientB={patientB} />
        </Modal>
    );
}

export { PatientMergeRequestCancellationConfirmationPopup };
